import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Router, Switch } from "react-router-dom";
import { createBrowserHistory } from "history";
import NetworkListener from "./NetworkListener"; 

export const history = createBrowserHistory();

// Prevent cut/copy/paste and right-click globally
const AppWrapper: React.FC = () => {
  useEffect(() => {
    const handleCopyCut = (e: ClipboardEvent) => {
      e.preventDefault();
     
    };

    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
    };

    document.addEventListener("copy", handleCopyCut);
    document.addEventListener("cut", handleCopyCut);
    document.addEventListener("contextmenu", handleContextMenu);

    return () => {
      document.removeEventListener("copy", handleCopyCut);
      document.removeEventListener("cut", handleCopyCut);
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  return (
    <>
      <NetworkListener /> 
      <Switch>
        <App />
      </Switch>
    </>
  );
};

ReactDOM.render(
  <Router history={history}>
    <AppWrapper />
  </Router>,
  document.getElementById("root")
);
